export default __webpack_public_path__ + "static/bao1-4d04daf4b4b54937febd38921f22e30e.png";